/** Purple Dot's injected "Learn more" (inside #pd-waitlist-info), same hook as live-theme. */
const LEARN_MORE_SELECTOR = '[data-purple-dot-waitlist] purple-dot-learn-more span';
const DESKTOP_QUERY = '(min-width: 990px)';

/**
 * Pre-order "learn more" dialog. Lives inside the PDP media column:
 * desktop opens it non-modal over the gallery (buy box stays usable),
 * mobile opens it as a full-screen modal. The click is caught in the capture
 * phase so Purple Dot's own iframe listener on the span never runs.
 */
class BtPreorderPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-bt-preorder-dialog]');
    if (!(this.dialog instanceof HTMLDialogElement)) return;

    this.media = window.matchMedia(DESKTOP_QUERY);

    this.onLearnMore = (event) => {
      if (!event.target.closest(LEARN_MORE_SELECTOR)) return;
      event.preventDefault();
      event.stopPropagation();
      this.open();
    };

    this.onClose = () => this.close();

    this.onDialogClick = (event) => {
      if (event.target.closest('.bt-preorder-dialog__panel')) return;
      this.close();
    };

    this.onKeyup = (event) => {
      if (event.code === 'Escape') this.close();
    };

    // Variant change on the PDP form: drop the dialog so the date can refresh.
    this.onFormChange = (event) => {
      if (event.target.closest('[data-purple-dot-waitlist]')) this.close();
    };

    // show() vs showModal() differ per breakpoint; close so the next open re-evaluates.
    this.onMediaChange = () => this.close();

    document.addEventListener('click', this.onLearnMore, true);
    document.addEventListener('change', this.onFormChange);
    document.addEventListener('keyup', this.onKeyup);
    this.media.addEventListener('change', this.onMediaChange);
    this.dialog.addEventListener('click', this.onDialogClick);
    this.querySelector('[data-bt-preorder-close]')?.addEventListener('click', this.onClose);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onLearnMore, true);
    document.removeEventListener('change', this.onFormChange);
    document.removeEventListener('keyup', this.onKeyup);
    this.media?.removeEventListener('change', this.onMediaChange);
  }

  open() {
    if (this.dialog.open) return;
    if (this.media.matches) {
      this.dialog.show();
      this.querySelector('[data-bt-preorder-close]')?.focus();
    } else {
      this.dialog.showModal();
    }
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }
}

if (!customElements.get('bt-preorder-popup')) {
  customElements.define('bt-preorder-popup', BtPreorderPopup);
}
